import React from "react";
import { FaMoneyBillWave, FaUsers, FaPiggyBank, FaChartLine, FaHandshake, FaShieldAlt } from "react-icons/fa";
import { Link } from "react-scroll";

const features = [
  {
    title: "Seamless Money Transfers & Payments",
    icon: <FaMoneyBillWave className="text-4xl text-orange-500" />,
    description: "Send and receive money to any MastaKash number instantly. Groups can now transact like individuals with lower costs and no network restrictions."
  },
  {
    title: "Bank-Grade Group Accounts",
    icon: <FaUsers className="text-4xl text-orange-500" />,
    description: "Ring-fenced sub-wallets ensure funds for group activities cannot be misappropriated. Instant balances, statements, and local outlet transactions."
  },
  {
    title: "Digital Savings & Merry-Go Solutions",
    icon: <FaPiggyBank className="text-4xl text-orange-500" />,
    description: "Auto merry-gos, fixed savings, and digital table banking help groups grow savings beyond geography, mobilizing millions for collective goals."
  },
  {
    title: "Smart Loans & Credit Tools",
    icon: <FaChartLine className="text-4xl text-orange-500" />,
    description: "Automated loan disbursement, custom loan products, credit score tracking, and Sukuma overdrafts enable flexible borrowing and growth."
  },
  {
    title: "Individual & Group Dashboards",
    icon: <FaHandshake className="text-4xl text-orange-500" />,
    description: "Manage personal finances and multiple group activities from one central dashboard. Connect with like-minded individuals locally or abroad."
  },
  {
    title: "Agent Opportunities",
    icon: <FaShieldAlt className="text-4xl text-orange-500" />,
    description: "Earn commissions by registering customers, issuing services, assisting KYC, and access business/finance literacy training."
  }
];

const FeaturesSection = () => {
  return (
    <section className="bg-purple-50 py-16" id="features">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-purple-900 mb-4">Features & Benefits</h2>
        <p className="text-purple-800 mb-12 max-w-2xl mx-auto">
          Discover how MastaKash empowers Individuals, Groups, and Agents to save, transact, and grow together with modern, secure, and convenient financial tools.
        </p>

        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-shadow duration-300">
              <div className="flex justify-center mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-purple-900 mb-2">{feature.title}</h3>
              <p className="text-purple-800">{feature.description}</p>
            </div>
          ))}
        </div>
        

        {/* Optional CTA */}
        <div className="mt-12">
         <a href=" https://appstore.roshtech.co.ke/apps/edad31f8-921e-4cb0-92dc-d7cbabd0bcde " target="_blank">
          <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full transition-colors duration-300">
            Get Started with MastaKash
          </button>
         </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
